import { render, staticRenderFns } from "./NonConformityDetail.vue?vue&type=template&id=885b74ac&scoped=true&"
import script from "./NonConformityDetail.vue?vue&type=script&lang=js&"
export * from "./NonConformityDetail.vue?vue&type=script&lang=js&"
import style0 from "./NonConformityDetail.vue?vue&type=style&index=0&id=885b74ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885b74ac",
  null
  
)

export default component.exports